// vietnamV2Language.ts
// ─── Astria Vietnam v2 — self-contained EN/VI language toggle ─────────────
// Scoped entirely to this feature — does NOT touch the app-wide i18next
// setup (src/i18n.ts) or any other country lane. Persists only the Vietnam
// V2 screen's own language choice, independent of the account's global
// `preferredLanguage`.
import { useCallback, useEffect, useState } from "react";

export type VietnamV2Lang = "en" | "vi";

const STORAGE_KEY = "astriaVietnamV2Lang";

export function getStoredVietnamV2Lang(): VietnamV2Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "vi") return stored;
  } catch {
    // localStorage unavailable — fall through to default
  }
  return "vi";
}

export function useVietnamV2Language(): [
  VietnamV2Lang,
  (lang: VietnamV2Lang) => void,
] {
  const [lang, setLangState] = useState<VietnamV2Lang>(getStoredVietnamV2Lang);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = useCallback((next: VietnamV2Lang) => {
    setLangState(next);
  }, []);

  return [lang, setLang];
}
